import { SiaActionConfig } from '@sia/actions';
import { FilterConfig, SiaChoiceItem } from '@sia/shared';
import { ColConfig } from './col-config';
import { EditParamConfig } from './edit-param-config';
import { StyleConfig } from './style-config';

export interface GridConfig {
  allowMerge?: boolean;
  mergeCustomMenu?: string;
  waitForFilter?: boolean;
  allowComparison?: boolean;
  reset?: boolean;
  gridId?: string;
  keyFields?: string;
  userId?: number;
  // editable?: boolean;
  editType?: string;

  editPopupArea1Title?: string; //Titolo Area 1
  editPopupArea2Title?: string; //Titolo Area 2
  editPopupWidth?: number;
  editPopupHeight?: number;
  editPopupColCount?: string;

  showBorders?: boolean;
  rowAlternationEnabled?: boolean;
  rowHeight?: number;
  hoverStateEnabled?: boolean;
  showColumnLines?: boolean;
  showRowLines?: boolean;

  exportFileName?: string;

  headerFilterEnabled?: boolean;
  filterRowEnabled?: boolean;

  // searchVisibleColumnsOnly?: boolean;
  groupPanelEnabled?: boolean;
  // stateSessionEnabled?: boolean;
  useSp?: boolean;

  controller?: string;
  allowUpdating?: boolean;
  updatingController?: string;
  allowMassiveUpdate?: boolean;
  allowMassiveDelete?: boolean;
  allowAdding?: boolean;
  addingController?: string;
  allowDeleting?: boolean;
  deletingController?: string;
  allowColumnReordering?: boolean;
  allowColumnResizing?: boolean;
  allowIdsSP?: boolean;
  idsSP?: string;
  idsSPActionName?: string;
  columnAutoWidth?: boolean;
  columnHidingEnabled?: boolean;
  columnResizingMode?: string;
  columnMinWidth?: string;
  scrollingType?: string;
  pageSize?: number;
  pageIndex?: number;
  useCache?: boolean;
  cacheKey?: string;
  externalPage?: string;
  cols?: ColConfig[];
  actions?: SiaActionConfig[];
  preFilters?: FilterConfig[];
  spParameters?: FilterConfig[];
  editParams?: EditParamConfig[];
  colStyles?: FilterConfig[];
  styleConditions?: StyleConfig[];
  allowRowReordering?: boolean;
  selectionMode?: string;
  actionColumnChooserEnabled?: boolean;
  actionExportExcelEnabled?: boolean;
  columnMinWidthNumber?: number;
  reportName?: string;
  reportParams?: string;
  reportVisibilityCondition?: string;
  actionSearchPanelEnabled?: boolean;
  exportEnabled?: boolean;
  choisesTitle?: string;
  choisesItems?: SiaChoiceItem[];
  //ignoreRouterParams?: boolean; // DEPRECATO ignoro i parametri in sessione se li gestisco manualmente attraverso dei filtri
  // userFilters?: FilterConfig[];
}

export class GridConfigClass implements GridConfig {
  reset: boolean = false;
  gridId: string = '';
  keyFields: string = '';
  userId: number = 0;
  waitForFilter: boolean = false;
  // editable: boolean= false;
  editType: string = '';

  editPopupArea1Title: string = ''; //Titolo Area 1
  editPopupArea2Title: string = ''; //Titolo Area 2
  editPopupWidth: number = 0;
  editPopupHeight: number = 0;
  editPopupColCount: string = '';
  mergeCustomMenu: string = '';
  showBorders: boolean = false;
  rowAlternationEnabled: boolean = false;
  rowHeight: number = 0;
  hoverStateEnabled: boolean = false;
  showColumnLines: boolean = false;
  showRowLines: boolean = false;

  exportFileName: string = '';

  headerFilterEnabled: boolean = false;
  filterRowEnabled: boolean = false;

  // searchVisibleColumnsOnly: boolean= false;
  groupPanelEnabled: boolean = false;
  // stateSessionEnabled: boolean= false;
  useSp: boolean = false;

  controller: string = '';
  allowUpdating: boolean = false;
  updatingController: string = '';
  allowAdding: boolean = false;
  addingController: string = '';
  allowDeleting: boolean = false;
  deletingController: string = '';
  allowMassiveUpdate: boolean = false;
  allowMassiveDelete: boolean = false;
  allowMerge: boolean = false;
  allowComparison: boolean = false;

  allowColumnReordering: boolean = false;
  allowColumnResizing: boolean = false;
  columnAutoWidth: boolean = false;
  columnHidingEnabled: boolean = false;
  allowIdsSP: boolean = false;
  idsSP: string = '';
  idsSPActionName: string = '';
  columnResizingMode: string = '';
  columnMinWidth: string = '';
  scrollingType: string = '';
  pageSize: number = 0;
  pageIndex: number = 0;
  useCache: boolean = false;
  cacheKey: string = '';
  externalPage: string = '';
  // stickyWidget: boolean= false;
  cols: ColConfig[] = [];
  actions: SiaActionConfig[] = [];
  preFilters: FilterConfig[] = [];
  spParameters: FilterConfig[] = [];
  editParams: EditParamConfig[] = [];
  colStyles: FilterConfig[] = [];
  styleConditions: StyleConfig[] = [];
  allowRowReordering: boolean = false;
  selectionMode: string = '';
  actionColumnChooserEnabled: boolean = false;
  // actionSearchPanelEnabled: boolean= false;
  actionExportExcelEnabled: boolean = false;
  exportEnabled: boolean = false;

  columnMinWidthNumber: number = 0;
  reportName: string = '';
  reportParams: string = '';
  reportVisibilityCondition: string = '';
  actionSearchPanelEnabled: boolean = false;
  choisesTitle: string = '';
  choisesItems: SiaChoiceItem[] = [];
}
